import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const HIDDEN = ["/", "/design-preview"];

function nextFor(path, loggedIn, search) {
  const diary = { to: "/timeline", label: "My diary" };
  if (path === "/account" || path === "/reset-password") {
    if (loggedIn) return diary;
    return new URLSearchParams(search).get("mode") === "create"
      ? { to: "/account", label: "Sign in instead" }
      : { to: "/account?mode=create", label: "Create account" };
  }
  if (!loggedIn) return { to: "/account", label: "Sign in" };
  if (path === "/timeline") return { to: "/add-memory", label: "Add a memory" };
  return diary;
}

export const PageNav = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  if (HIDDEN.includes(pathname)) return null;

  const next = nextFor(pathname, !!user, search);
  const back = () => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate(user && pathname !== "/timeline" ? "/timeline" : "/");
  };

  return (
    <nav
      data-testid="page-nav"
      className="no-print sticky top-0 z-40 h-16 border-b border-[#EBE4DA] bg-[#FAF6F0]/95 px-4 backdrop-blur-md"
    >
      <div className="mx-auto flex h-full max-w-6xl items-center justify-between gap-3">
        <button
          data-testid="page-nav-back"
          onClick={back}
          className="inline-flex min-h-[48px] items-center gap-2 rounded-full border-2 border-[#36858B] bg-white px-5 text-base font-semibold text-[#245E63] transition-colors hover:bg-[#EBF4F5] sm:px-6"
        >
          <ArrowLeft size={20} weight="bold" /> Back
        </button>
        <button
          data-testid="page-nav-next"
          onClick={() => navigate(next.to)}
          className="inline-flex min-h-[48px] min-w-0 items-center gap-2 rounded-full bg-[#E06D53] px-5 text-base font-semibold text-white shadow-md shadow-[#E06D53]/25 transition-colors hover:bg-[#C85B43] sm:px-6"
        >
          <span className="truncate"><span className="hidden min-[380px]:inline">Next: </span>{next.label}</span> <ArrowRight size={20} weight="bold" className="shrink-0" />
        </button>
      </div>
    </nav>
  );
};
